import {Injectable} from '@angular/core';
import { RosterPreferenceApi } from 'src/app/api/roster-preference.api';

@Injectable()
export class RosterPreferenceService {

    constructor(
        private rosterPreferenceApi: RosterPreferenceApi
    ) { }

    getRosterPreferenceValidationForRequestItem = (requestId: string) => 
        this.rosterPreferenceApi.getRosterPreferenceValidationForRequestItem(requestId);

    getRosterPreferenceValidationForUserRequest = (userRequestId: string) =>
        this.rosterPreferenceApi.getRosterPreferenceValidationForUserRequest(userRequestId);
}